import React, { useEffect, useState } from "react";
import { getDonorDonationHistory } from "../api/donorPanelApi";
import DonationHistoryDirectorySection from "../components/DonationHistoryDirectorySection";
import "../../user-builder/styles/userBuilder.css";
import "../../user-builder/styles/UserBuilderPage.css";

export default function DonorDonationHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getDonorDonationHistory();
        if (!alive) return;
        setRows(Array.isArray(res?.data) ? res.data : []);
      } catch (err) {
        if (!alive) return;
        setError(err?.message || "Failed to load donation history");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="user-builder-panel" style={{ width: "100%", maxWidth: "100%" }}>
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Donation history</h3>
        <p className="user-builder-panel__hint">
          View your past donations with filters, column picker, and export — same
          directory layout as other app screens.
        </p>
      </div>

      <DonationHistoryDirectorySection rows={rows} loading={loading} error={error} />
    </div>
  );
}
